module.exports = __webpack_public_path__ + "img/safari.4b0156ef.svg";